import f3tch from 'f3tch';

import profile from '../../api/profiles/noData.profile.api';

export default (tagId) =>
  f3tch(`/crm/tags/${tagId}/`).profile(profile()).delete();
